import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MERCH_MANAGER_EDITOR } from "../routes/routes";

export function useAutoSelectFromUrl(list, targetId, onSelect, showingItems) {
  const itemRefs = useRef({});
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!targetId) {
      setNotFound(false);
      return;
    }
    if (!list?.length) return;
    const match = list.find((r) => r.id === targetId);
    if (match) {
      setNotFound(false);
      onSelect(match);
      itemRefs.current[targetId]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else {
      setNotFound(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetId, list]);

  const targetedRequest = targetId ? list.find((r) => r.id === targetId) : null;

  const listToRender = targetedRequest
    ? [targetedRequest]
    : list.slice(0, showingItems);

  const returnLink = targetId && (
    <button
      onClick={() => navigate(`/${MERCH_MANAGER_EDITOR}/?tab=pending`)}
      className="text-sm text-primary hover:underline mb-3"
    >
      ← Back to all pending requests
    </button>
  );

  return { itemRefs, notFound, listToRender, returnLink };
}
